var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4759 8.70717C9.18016 8.88916 9 9.21156 9 9.55882V18.25H7.5V10H4C2.89543 10 2 10.8954 2 12V18.25C1.58579 18.25 1.25 18.5858 1.25 19C1.25 19.4142 1.58579 19.75 2 19.75H22C22.4142 19.75 22.75 19.4142 22.75 19C22.75 18.5858 22.4142 18.25 22 18.25V9.55882C22 9.21156 21.8198 8.88916 21.5241 8.70717L16.5482 5.64507C15.9054 5.24949 15.0946 5.24949 14.4518 5.64507L9.4759 8.70717ZM18 18.25H13V15.5C13 14.1193 14.1193 13 15.5 13C16.8807 13 18 14.1193 18 15.5V18.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome7);
export default __webpack_public_path__ + "static/media/home-7.90a6710ca67aa6c6fce3104e5b847bf7.svg";
export { ForwardRef as ReactComponent };